import React from 'react';
import { Link } from 'react-router-dom';
import { PROJECTS } from '../../data';
import ProjectCard from '../molecules/ProjectCard';

const FeaturedWork = () => {
    return (
        <section id="work" className="py-32 px-6 md:px-12 bg-[#fbfbf4] text-[#050505]">
            <div className="flex flex-col md:flex-row justify-between items-end mb-20 border-b border-black/10 pb-8">
                <h2 className="font-migra text-5xl md:text-8xl mb-6 md:mb-0">Featured Work</h2>
                <p className="block md:block max-w-xs text-sm opacity-60">Design without compromise. Explore my blend of digital product design and web development.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-32">
                {PROJECTS.map((project, i) => (
                    <ProjectCard key={project.id} project={project} index={i} />
                ))}
            </div>

            <div className="mt-32 text-center">
                <Link to="/work" className="inline-block px-12 py-5 border border-black rounded-full hover:bg-black hover:text-white transition-all text-xs uppercase tracking-widest font-bold">
                    View All Deployments
                </Link>
            </div>
        </section>
    );
};

export default FeaturedWork;
